import React from 'react';
import { formatPrice } from '../../utils/format';
import './BookingSummaryBar.css';

/** Riepilogo fisso in basso (mobile) con totale e CTA. */
export function BookingSummaryBar({ summary, total, ctaLabel = 'Conferma', onCta, disabled = false }) {
  return (
    <div className="vc-booking-summary-bar md:hidden">
      <div className="vc-booking-summary-bar__inner">
        <div className="vc-booking-summary-bar__meta">
          {summary && <p className="vc-booking-summary-bar__summary">{summary}</p>}
          {total != null && (
            <p className="vc-booking-summary-bar__total">{formatPrice(total)}</p>
          )}
        </div>
        <button
          type="button"
          className="vc-booking-summary-bar__cta"
          disabled={disabled}
          onClick={onCta}
        >
          {ctaLabel}
        </button>
      </div>
    </div>
  );
}
